import { all, call, put, takeLatest } from 'redux-saga/effects';

import { apiFetchDistricts, apiFetchStudentDistricts } from '../services/apis';
import * as actions from '../redux/district';
import { fetchSchools } from '../redux/schools';
import { actions as errorActions } from '@dragonfruit/redux/error';

function* fetchDistrictFlow(action) {
  const { country, prefetchSchool, role } = action.payload;

  const { id } = country;

  try {
    const response = yield call(apiFetchDistricts, id);

    yield put(actions.fetchDistrictsSuccess(response.data));

    if (prefetchSchool) {
      const [district] = response.data;

      yield put(actions.storePrefetchedDistrict(district));

      if (district) {
        yield put(
          fetchSchools({
            region: id,
            district,
            role,
          })
        );
      }
    }
  } catch (error) {
    yield put(actions.fetchDistrictsFailed(error.message));
    yield put(errorActions.sendError(error));
  }
}

function* fetchStudentDistrictFlow(action) {
  const { country } = action.payload;

  const { id } = country;

  try {
    const response = yield call(apiFetchStudentDistricts, id);

    yield put(actions.fetchDistrictsSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchDistrictsFailed(error.message));
  }
}

export default function*() {
  yield all([
    takeLatest(actions.FETCH_DISTRICTS, fetchDistrictFlow),
    takeLatest(actions.FETCH_STUDENT_DISTRICTS, fetchStudentDistrictFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/district.js